import { render } from "./Roundtable.vue?vue&type=template&id=4fb21750&scoped=true"
import script from "./Roundtable.vue?vue&type=script&lang=js"
export * from "./Roundtable.vue?vue&type=script&lang=js"

import "./Roundtable.vue?vue&type=style&index=0&id=4fb21750&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb21750"]])

export default __exports__